// Helper function to handle comma validation
export const handleCommaCheck = (value: string): boolean => {
    return value.includes(",");
};
